import { schema } from "normalizr";
import { PageLink as Record } from "records/page";
import { MediaSchema } from "schemas/media";
import { AssetSchema } from "schemas/asset";

export const PageLinkSchema = new schema.Entity("pageLinks", {
    asset: AssetSchema,
    media: MediaSchema,
});

(PageLinkSchema as any).record = Record;
